import LPMainTop from './mainCompotents/top';
import LPStats from './mainCompotents/stats';
import LPFeatures from './mainCompotents/features';
import LPPreview from './mainCompotents/preview';
import LPCta from './mainCompotents/cta';

function LPMain() {
    return (
        <main className="pt-16">
            <LPMainTop/>
            <LPStats/>
            <LPFeatures/>
            <LPPreview/>
            <LPCta/>
        </main>
    );
}

export default LPMain;